import { HStack, Text } from '@chakra-ui/react';
import { AgeGroup } from '@novaheal/types';
import { AdultIcon, KidsIcon, SeniorIcon } from 'assets/icons/v2';
import { TooltipWithTouch } from 'components/common/TooltipWithTouch';
import { ReactElement } from 'react';

type AgeGroupIconProps = {
  ageGroup: AgeGroup;
};

const AgeGroupIcon = ({ ageGroup }: AgeGroupIconProps): ReactElement => {
  const getIcon = (): ReactElement => {
    switch (ageGroup) {
      case AgeGroup.CHILDREN:
        return <KidsIcon boxSize="14px" color="icon.tertiary" />;
      case AgeGroup.ADULTS:
        return <AdultIcon boxSize="14px" color="icon.tertiary" />;
      case AgeGroup.SENIORS:
        return <SeniorIcon boxSize="14px" color="icon.tertiary" />;
      default:
        return <AdultIcon boxSize="14px" color="icon.tertiary" />;
    }
  };

  const getAgeGroupLabel = (): string => {
    switch (ageGroup) {
      case AgeGroup.CHILDREN:
        return 'Kinder';
      case AgeGroup.ADULTS:
        return 'Erwachsene';
      case AgeGroup.SENIORS:
        return 'Senior:innen';
      default:
        return 'Erwachsene';
    }
  };

  return (
    <TooltipWithTouch hasArrow label={<Text>{getAgeGroupLabel()}</Text>}>
      {getIcon()}
    </TooltipWithTouch>
  );
};

type AgeGroupIconsProps = {
  ageGroups: AgeGroup[];
};

const AgeGroupIcons = ({ ageGroups }: AgeGroupIconsProps): ReactElement => {
  return (
    <HStack textStyle="body.s.regular" color="icon.tertiary" gap="5px">
      {ageGroups.map((ageGroup) => (
        <AgeGroupIcon key={ageGroup} ageGroup={ageGroup} />
      ))}
    </HStack>
  );
};

export default AgeGroupIcons;
